import { useEffect, useState } from "react";
import { PROFILE } from "../lib/profile";

const WhatsappIcon = ({ className = "" }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className={className}
    >
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.611-.916-2.206-.242-.58-.487-.5-.669-.51a12.83 12.83 0 0 0-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.695.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.861 9.861 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0 0 20.464 3.488" />
    </svg>
);

/**
 * Floating WhatsApp button — visible on ALL breakpoints (mobile + desktop).
 * Positioned bottom-right, above the Emergent badge on mobile.
 * Label "WhatsApp" always visible.
 */
export default function WhatsAppFloating() {
    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        // Nudge tooltip once after mount so users see the label
        const t = setTimeout(() => setShowTooltip(true), 1200);
        const t2 = setTimeout(() => setShowTooltip(false), 4500);
        return () => {
            clearTimeout(t);
            clearTimeout(t2);
        };
    }, []);

    return (
        <div
            className="fixed right-3 sm:right-5 bottom-[72px] sm:bottom-6 z-50 flex flex-col items-end gap-2 pointer-events-none"
            data-testid="whatsapp-floating-wrap"
        >
            {/* Label chip (always visible on mobile, auto-shows on desktop on load) */}
            <a
                href={PROFILE.whatsapp(
                    "Hola Gilberto, me interesa conversar sobre un proyecto.",
                )}
                target="_blank"
                rel="noopener noreferrer"
                className={`pointer-events-auto bg-white border border-navy/15 text-navy px-3 py-1.5 text-xs font-medium shadow-md rounded-full flex items-center gap-1.5 transition-all duration-500
                    ${showTooltip ? "opacity-100 translate-x-0" : "opacity-0 translate-x-2 sm:opacity-100 sm:translate-x-0"}
                    hidden sm:flex`}
                aria-hidden="true"
                tabIndex={-1}
                data-testid="whatsapp-label"
            >
                <span className="w-2 h-2 rounded-full bg-[#25D366] animate-pulse" />
                WhatsApp · {PROFILE.phoneDisplay}
            </a>

            {/* Main pill button — icon + label, always visible */}
            <a
                href={PROFILE.whatsapp(
                    "Hola Gilberto, me interesa conversar sobre un proyecto.",
                )}
                target="_blank"
                rel="noopener noreferrer"
                className="pointer-events-auto group relative inline-flex items-center gap-2.5 bg-[#25D366] hover:bg-[#1FB855] text-white pl-3 pr-4 py-3 rounded-full shadow-xl transition-all hover:scale-[1.03] active:scale-95"
                aria-label={`WhatsApp ${PROFILE.phoneDisplay}`}
                data-testid="floating-whatsapp"
            >
                <span className="relative flex items-center justify-center w-8 h-8 bg-white/20 rounded-full">
                    <WhatsappIcon className="w-5 h-5" />
                    <span className="absolute inset-0 rounded-full bg-white/40 animate-ping opacity-75" />
                </span>
                <span className="font-medium tracking-wide text-sm">
                    WhatsApp
                </span>
            </a>
        </div>
    );
}
